<template lang="pug">
  ul.nav.nav-tabs.nav-515
    router-link(:to="{name: 'patient.agendas.search.professional'}", tag="li")
      a Busca por Nome
    router-link(:to="{name: 'patient.agendas.search.speciality'}", tag="li")
      a Busca por Especialidade
    router-link(:to="{name: 'patient.agendas.search.advanced'}", tag="li")
      a Busca Avançada
    slot
</template>

<script>
export default {
  name: 'search-options'
}
</script>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/advanced/components/search-options.vue